import React, { Component } from "react";
import { Row, Col, Space, Image } from "antd";
import { Link } from "react-router-dom";
import "../../App.css";

export default class TangTen extends Component {
  render() {
    const arr1 = [];
    for (let i = 0; i < 3; i++) {
      arr1[i] = i;
    }
    const arr2 = [];
    for (let i = 3; i < 7; i++) {
      arr2[i] = i;
    }
    return (
      <>
        <Row>
          <Col xs={0} sm={1} md={1} lg={2} xl={2}></Col>
          <Col xs={24} sm={22} md={22} lg={20} xl={20}>
            <Row justify="center">
              <Col span={24} className="paddLR10">
                <Link className="breadCrumbText link" to="/home">
                  Home
                </Link>
                &nbsp;&gt;&nbsp;
                <Link className="breadCrumbText link" to="/visdev">
                  VisDev Projects
                </Link>
              </Col>
              <Col span={24} className="visdevTitle paddLR10">
                Tang & Ten
              </Col>
              <Col span={24} className="paddTop60"></Col>
            </Row>
          </Col>
          <Col xs={0} sm={1} md={1} lg={2} xl={2}></Col>
        </Row>
        <Row className="bgColorGray" justify="center">
          <Col xs={0} sm={1} md={1} lg={2} xl={2}></Col>
          <Col xs={24} sm={22} md={22} lg={20} xl={20}>
            <Row>
              <Col span={24} className="paddTop40 paddLR10">
                <Space size="large" direction="vertical">
                  {arr1.map((item) => {
                    return (
                      <Image
                        alt={`Tang and Ten ${item} Image`}
                        src={`${process.env.PUBLIC_URL}/images/jpg/TangTen_${item}.jpg`}
                        className="img100"
                        loading="lazy"
                        preview={false}
                        placeholder={
                          <Image
                            src={`${process.env.PUBLIC_URL}/images/jpg/TangTen_${item}_blur.jpg`}
                            className="img100"
                            preview={false}
                          />
                        }
                      />
                    );
                  })}
                  <div className="fAN color110 f2EM paddTop60">
                    Key Scene Paintings
                  </div>
                  {arr2.map((item) => {
                    return (
                      <Image
                        alt={`Tang and Ten ${item} Image`}
                        src={`${process.env.PUBLIC_URL}/images/jpg/TangTen_${item}.jpg`}
                        className="img100"
                        loading="lazy"
                        preview={false}
                        placeholder={
                          <Image
                            src={`${process.env.PUBLIC_URL}/images/jpg/TangTen_${item}_blur.jpg`}
                            className="img100"
                            preview={false}
                          />
                        }
                      />
                    );
                  })}
                </Space>
              </Col>
              <Col span={24} className="paddTop40"></Col>
            </Row>
          </Col>
          <Col xs={0} sm={1} md={1} lg={2} xl={2}></Col>
        </Row>
        <Row>
          <Col span={24} className="rH100"></Col>
        </Row>
      </>
    );
  }
}
